import { useRouter } from 'next/router';

import { BasePost, Category } from '../../src/types/blog';
import SideBarItem from './items/sideBarItem';

type SideBarProps = {
  recentPosts: BasePost[];
  categories: Category[];
};

export default function SideBar({ recentPosts, categories }: SideBarProps) {
  const { isPreview } = useRouter();

  if (isPreview) {
    return (
      <div className="flex flex-col items-center justify-center h-full">
        <span className="text-xl text-gray-500">preview mode</span>
      </div>
    );
  }

  return (
    <>
      <div>
        <p className="text-2xl font-bold mb-6">Categorías Blog</p>
        <div className="space-y-5">
          {categories.map(category => (
            <SideBarItem key={category.id} category={category} />
          ))}
        </div>
      </div>

      <div>
        <p className="text-2xl font-bold mb-6">Últimas Publicaciones</p>
        <div className="space-y-5">
          {recentPosts.map(post => (
            <SideBarItem key={post.id} post={post} />
          ))}
        </div>
      </div>
    </>
  );
}
